const query = () => {
  return `
      query {
        me {
          id,
          name,
          photo_small,
          email,
          account {
            id,
            tier
          }
        }
      }
  `;
};

export default query;
